import { Component, input, OnInit, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { Fertilizer, FertilizerType } from '../../models/fertilizer.model';

@Component({
  selector: 'app-manure-period',
  templateUrl: './manure-period.component.html',
  styleUrls: ['./manure-period.component.scss'],
  standalone: false,
})
export class ManurePeriodComponent implements OnInit {
  protected readonly locale = inject(LocaleService);

  fertilizers = input<Fertilizer[]>([]);
  isLoaded = input<boolean>(false);

  initialStockFertilizers: Fertilizer[] = [];
  notDeliveredFertilizers: Fertilizer[] = [];
  deliveredFertilizers: Fertilizer[] = [];
  dispatchedFertilizers: Fertilizer[] = [];
  closingStockFertilizers: Fertilizer[] = [];

  ngOnInit(): void {
    this.filterFertilizers();
  }

  private filterFertilizers(): void {
    const fertilizers = this.fertilizers();
    if (!fertilizers) {
      return;
    }

    this.deliveredFertilizers = fertilizers.filter(
      ({ fertilizerType }) => fertilizerType === FertilizerType.Delivered,
    );
    this.notDeliveredFertilizers = fertilizers.filter(
      ({ fertilizerType }) => fertilizerType === FertilizerType.NotDelivered,
    );

    this.initialStockFertilizers = fertilizers.filter(
      ({ fertilizerType }) => fertilizerType === FertilizerType.InitialStock,
    );

    this.closingStockFertilizers = fertilizers.filter(
      ({ fertilizerType }) => fertilizerType === FertilizerType.ClosingStock,
    );

    this.dispatchedFertilizers = fertilizers.filter(
      ({ fertilizerType }) => fertilizerType === FertilizerType.Dispatched,
    );
  }
}
